import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../data/site";

const fade = (i = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.55, delay: i * 0.08 },
});

const FACTS = [
  { value: "8 yrs", label: "In business" },
  { value: "1", label: "Bloke — Sam" },
  { value: "100%", label: "Mobile service" },
];

export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="py-20 sm:py-24 lg:py-32 border-t border-line bg-surface/40"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
      <motion.div {...fade()} className="lg:col-span-4">
        <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-orange-500 font-semibold mb-4">
          The bloke behind the van
        </p>
        <h2
          data-testid="about-heading"
          className="font-display font-bold uppercase tracking-tight text-slate-50 text-3xl sm:text-4xl lg:text-5xl leading-[0.95]"
        >
          About Sam.
        </h2>
      </motion.div>

      <div className="lg:col-span-8">
        <motion.div {...fade(1)} className="space-y-6 text-slate-300 text-base sm:text-lg leading-relaxed max-w-2xl">
          <p>
            SWS is a one-man operation, and that's the point. When you call,
            you talk to Sam. When the van pulls up, it's Sam who does the work —
            no apprentices, no handballing, no run-around.
          </p>
          <p>
            Eight years on, that's still how every job runs: straight answers
            before the work starts, tidy workmanship, and an honest
            recommendation if a repair can wait.
          </p>
          <p>
            Auto electrical and auto air conditioning across the Sunshine Coast
            — cars, 4x4s, caravans and everything in between.
          </p>
        </motion.div>

        <motion.div {...fade(2)} className="mt-10 grid grid-cols-3 gap-4 max-w-2xl">
          {FACTS.map((f) => (
            <div
              key={f.label}
              data-testid={`about-fact-${f.label.replace(/[^a-z]/gi, "").toLowerCase()}`}
              className="rounded-xl border border-line bg-surface px-4 py-5 text-center sm:text-left"
            >
              <p className="font-display font-bold text-2xl sm:text-3xl text-orange-500 leading-none">
                {f.value}
              </p>
              <p className="font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.18em] text-slate-400 mt-2">
                {f.label}
              </p>
            </div>
          ))}
        </motion.div>

        <motion.a
          {...fade(3)}
          href={PHONE_TEL}
          data-testid="about-call-cta"
          className="mt-10 inline-flex items-center gap-2.5 px-7 py-3.5 rounded-full border border-line bg-surface hover:border-orange-600/60 hover:text-orange-400 text-slate-200 font-semibold text-[15px] transition-colors"
        >
          <Phone size={17} />
          Talk to Sam directly — {PHONE_DISPLAY}
        </motion.a>
      </div>
    </div>
  </section>
);
